/**
 * PerformanceBonusTile.mask.ts
 *
 * Data-masking logic for PerformanceBonusTile.
 * When showData is false, sensitive values are replaced with "--" / neutral defaults
 * so no real data is visible.
 */
import type { HeaderVariant } from "../../../../services/MonthlyPerformanceIncome/monthlyPerformanceIncomeAPI.types";

const MASKED_VALUE = "--";

// ─── PerformanceBonusTile ────────────────────────────────────────────────────

export interface PerfBonusTick {
  value: number;
  label: string;
  gpvValue: number;
}

export interface PerfBonusMilestone {
  id: string;
  value: number;
  achieved: boolean;
}

export interface PerfBonusLegend {
  id: string;
  label: string;
  achieved: boolean;
  gpvValue: number;
}

export interface PerfBonusScaleData {
  max: number;
  progressValue: number;
  ticks: PerfBonusTick[];
  milestones: PerfBonusMilestone[];
  legends: PerfBonusLegend[];
}

export interface PerfBonusTileData {
  totalGpv: string;
  performanceBonusPercent: string;
  qualifiedLegs: string;
  isSpQualified: boolean;
  headerVariant: HeaderVariant;
  gpvNeeded: string;
  percentNeeded: string;
  scaleData: PerfBonusScaleData;
}

export const maskPerfBonusTileData = (data: PerfBonusTileData, showData: boolean): PerfBonusTileData => {
  if (showData) return data;
  return {
    totalGpv: MASKED_VALUE,
    performanceBonusPercent: MASKED_VALUE,
    qualifiedLegs: "0",
    isSpQualified: false,
    headerVariant: "gpvNeeded",
    gpvNeeded: MASKED_VALUE,
    percentNeeded: MASKED_VALUE,
    scaleData: {
      ...data.scaleData,
      progressValue: 0,
      milestones: [],
      legends: [],
    },
  };
};
